import {
  SHIFT_CREATOR_EDIT_SEARCH,
  SHIFT_CREATOR_EDIT_SEARCH_FAILURE,
  SHIFT_CREATOR_EDIT_SEARCH_SUCCESS,
  SHIFT_CREATOR_UPDATE,
  SHIFT_CREATOR_UPDATE_FAILURE,
  SHIFT_CREATOR_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    shiftCreators: [],
    shop: null
  },
  getters: {
    shiftEditCreators: state => {
      return state.shiftCreators
    },
    shiftEditCreatorShop: state => {
      return state.shop
    }
  },
  actions: {
    [SHIFT_CREATOR_EDIT_SEARCH] ({dispatch, state, commit}, params = null) {
      var data = {}
      var url = '/master/shift_creators/' + params.id + '/edit'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_CREATOR_EDIT_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(SHIFT_CREATOR_EDIT_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHIFT_CREATOR_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = {}
      var url = '/master/shift_creators/' + params.id
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_CREATOR_UPDATE_FAILURE, res.data)
          } else {
            commit(SHIFT_CREATOR_UPDATE_SUCCESS, { data: data, callback: callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHIFT_CREATOR_EDIT_SEARCH_FAILURE] (state, params) {
      console.log('SHIFT_CREATOR_EDIT_SEARCH_FAILURE')
    },
    [SHIFT_CREATOR_EDIT_SEARCH_SUCCESS] (state, params) {
      console.log('SHIFT_CREATOR_EDIT_SEARCH_SUCCESS')
      var data = params.data
      state.shiftCreators = data.users.data
      state.shop = data.shop.data
      if (params.callback) {
        params.callback()
      }
    },
    [SHIFT_CREATOR_UPDATE_FAILURE] (state, params) {
      console.log('SHIFT_CREATOR_UPDATE_FAILURE')
    },
    [SHIFT_CREATOR_UPDATE_SUCCESS] (state, params) {
      console.log('SHIFT_CREATOR_UPDATE_SUCCESS')
      if (params.callback) {
        params.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shift-creator-edit.js